import { useMemo } from 'react';
import { Link } from 'react-router-dom';
import SectionHeading from '@/components/base/SectionHeading';
import VideoCard from '@/components/base/VideoCard';
import type { Video } from '@/types/content';
import { getRelated } from '@/lib/videos';

export default function RelatedVideos({ video }: { video: Video }) {
  const related = useMemo(() => getRelated(video, 8), [video]);

  if (related.length === 0) return null;

  return (
    <section className="bg-background-100/70">
      <div className="mx-auto w-full max-w-7xl px-4 py-10 md:px-8 md:py-14">
        <SectionHeading
          icon="ri-magic-line"
          title="相关推荐"
          subtitle="同分类及猜你喜欢的男同主题内容"
        />
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
          {related.map((item) => (
            <VideoCard key={item.id} video={item} />
          ))}
        </div>
      </div>
    </section>
  );
}